export default "__VITE_ASSET__DYks$hX0__"